import { ModuleWithProviders, NgModule } from '@angular/core';

import { BROWSER_GLOBALS_PROVIDERS } from './browser-globals';
import { LAZY_MAPS_API_CONFIG, LazyMapsAPILoader, LazyMapsAPILoaderConfigLiteral } from './lazy-maps-api-loader';
import { MapsAPILoader } from './maps-api-loader';

@NgModule()
export class AgmCoreModule {
  /**
   * Please use this method when you register the module at the root level.
   */
  static forRoot(lazyMapsAPILoaderConfig?: LazyMapsAPILoaderConfigLiteral): ModuleWithProviders<any> {
    return {
      ngModule: AgmCoreModule,
      providers: [
        ...BROWSER_GLOBALS_PROVIDERS,
        {
          provide: MapsAPILoader,
          useClass: LazyMapsAPILoader,
        },
        {
          provide: LAZY_MAPS_API_CONFIG,
          useValue: lazyMapsAPILoaderConfig,
        },
      ],
    };
  }
}
